import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useArchivedBookmarks } from '../services/dataHooks';

export const Route = createFileRoute('/_app/archive/read/$id')({
  component: ArchiveReadPage,
});

function ArchiveReadPage() {
  const { preferences } = useUserPreferences();
  const { bookmarks, isLoading: isBookmarkCollectionLoading } = useArchivedBookmarks();

  return (
    <BookmarkListPage
      mode="archive"
      bookmarks={bookmarks || []}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
    />
  );
}
